import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { StationDetail } from './../../../yard-local/shared/model/station-detail.model';

/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/


/**
 * @export
 * @class LmsStationIconSvgComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-station-icon-svg',
  templateUrl: './lms-station-icon-svg.component.html',
  styleUrls: ['./lms-station-icon-svg.component.scss']
})
export class LmsStationIconSvgComponent implements OnInit, OnDestroy {

  @Input() stationDetail: StationDetail;
  public outerBorderClass: string;
  public innerBackgroundColor: string;
  public cityName: string;
  public state: string;
  public mnemonic: string;
  public lmsDesk: string;
  public associatedStatusTime: string;
  public allotment: number;
  public compliance: string;
  public divisionAbbrevation: string;
  public isAllotmentVisible: boolean;

  /*Light Purple (which often looks Pink) indicates that one or both required GPS geo fences
   do not exist. Each allocation station should have an Allocation Station geo fence and a Geographic
   geo fence. */
  private isPinkInnerBackground: boolean;
  /* Red indicates the total number of units allocated does not match the total planned
    allotment (under-allocated). */
  private isRedInnerBackground: boolean;
  /* Green Indicates the total number of units allocated meets or exceeds the total planned allotment,
   and the number of units allocated for each type meets or exceeds the planned allotment for each type.
    (The mix is correct). */
  private isGreenInnerBackground: boolean;
  /* Yellow Indicates the total number of units allocated meets or exceeds the planned allotment.
  However, the number of units allocated for each type does not always meet or exceed the planned
  allotment for each type. (The mix is wrong). */
  private isYellowInnerBackground: boolean;

  private defaultOuterBorder = 'default-outer-border';
  private lightPurpleBackground = 'light-purple-background';
  private redBackground = 'red-background';
  private greenBackground = 'green-background';
  private yellowBackground = 'yellow-background';
  private whiteBackground = 'white-background';

  constructor() { }

  /**
   * This method initializes the drawing of station SVG
   * @memberOf LmsStationIconSvgComponent
   */
  ngOnInit() {
    if (this.stationDetail) {
      this.cityName = this.stationDetail.allocStationCity;
      this.state = this.stationDetail.allocStationState;
      this.mnemonic = this.stationDetail.allocStation;
      this.lmsDesk = this.stationDetail.lmsDesk;

      if (this.stationDetail.stationRowNum === 1) {
        this.divisionAbbrevation = this.lmsDesk;
        this.outerBorderClass = this.defaultOuterBorder;

        if (this.isNotBlank(this.stationDetail.inCompliance) &&
          this.trimUpperCaseValue(this.stationDetail.inCompliance) === 'G') {
          this.innerBackgroundColor = this.greenBackground;

        } else if (this.isNotBlank(this.stationDetail.inCompliance) &&
          this.trimUpperCaseValue(this.stationDetail.inCompliance) === 'R') {
          this.innerBackgroundColor = this.redBackground;

        } else if (this.isNotBlank(this.stationDetail.inCompliance) &&
          this.trimUpperCaseValue(this.stationDetail.inCompliance) === 'Y') {
          this.innerBackgroundColor = this.yellowBackground;

        } else if (this.isNotBlank(this.stationDetail.inCompliance) &&
          this.trimUpperCaseValue(this.stationDetail.inCompliance) === 'P') {
          this.innerBackgroundColor = this.lightPurpleBackground;

        } else {
          this.innerBackgroundColor = this.whiteBackground;
        }
        this.isAllotmentVisible = true;
        if (this.stationDetail.totalAllotment && !isNaN(Number(this.stationDetail.totalAllotment))) {
          this.allotment = Number(this.stationDetail.totalAllotment);
        }

      } else if (this.stationDetail.stationRowNum === 2) {
        this.divisionAbbrevation = 'Other Y/L Units';
        this.isAllotmentVisible = false;
      } else if (this.stationDetail.stationRowNum === 3) {
        this.divisionAbbrevation = 'Road Units';
        this.isAllotmentVisible = false;
      } else if (this.stationDetail.stationRowNum === 4) {
        this.divisionAbbrevation = 'MOW Units';
        this.isAllotmentVisible = false;
      } else if (this.stationDetail.stationRowNum === 5) {
        this.divisionAbbrevation = 'Special Allocation';
        this.isAllotmentVisible = false;
      } else if (this.stationDetail.stationRowNum === 6) {
        this.divisionAbbrevation = 'Unallocated MOW';
        this.isAllotmentVisible = false;
      }
    }
  }

  /**
   * @memberOf LmsStationIconSvgComponent
   */
  ngOnDestroy() {
  }


  /**
 * This is used to check whether value is blank or note
 * @param {string} value
 * @returns {boolean}
 * @memberOf LmsStationIconSvgComponent
 */
  isNotBlank(value: string): boolean {
    return (value && value.trim().length > 0);
  }

  /**
   * This is used to convert into UpperCase
   * @param {string} value
   * @returns {string}
   * @memberOf LmsStationIconSvgComponent
   */
  trimUpperCaseValue(value: string): string {
    return value && value.trim().toUpperCase();
  }
}
